<template>
  <ui-card class="px-3 py-3 ui-table-actions" elevation="24" :flat="false" color="white">
    <div class="d-flex align-center">
      <ui-button round is-icon @click="onClose">
        <v-icon> mdi-close </v-icon>
      </ui-button>

      <div class="primary--text text-body-1 font-weight-bold ml-2 mr-1">
        {{ selectedCount }}
      </div>

      <div class="text-body-1 mr-4 mr-sm-16">
        {{ selectedText }}
      </div>

      <div class="d-flex">
        <slot />
      </div>
    </div>
  </ui-card>
</template>
<script>
export default {
  name: 'UITableActions',
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    selectedText() {
      return this.$t('base.selected').toLowerCase()
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.ui-table-actions {
  position: fixed;
  bottom: 63px;
  // half of the sidebar (28px when collapsed, 122px when expanded)
  left: calc(50% + var(--sidebar-half-width, 122px));
  // same easing as the sidebar collapse
  transition: left 200ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: translate3d(-50%, 0, 0);
  // 100% minus (sidebar with + indent to main area)
  max-width: calc(100% - 2 * var(--sidebar-half-width, 122px) - 20px);
  z-index: 99;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
    max-width: 100vw;
  }
}
</style>
